import _ from 'lodash';
import cx from 'classnames';

import { MENU, MENU_CONTAINER } from 'constants/widgetTypes';
import styles from './palette.module.scss';
import shortid from 'shortid';
import { guid } from 'services/util';

const generateMenuData = (menuType) => {

  switch (menuType) {
    case 'basic':
      return {
        type: MENU,
        name: "Menu",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 553px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "100px"
            },
            "stretched": false,
            "padding": 0,
            "container": {
              "minWidth": 1200,
              "alignment": "center"
            },
            "scrollEffect": "NONE",
            "background": {
              "type": "color",
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "media": null,
              "opacity": 0,
              "scale": null,
              "position": null
            },
            "alignment": {
              "position": "center",
              "margin": null
            },
            "verticalAlignment": {
              "position": "center",
              "margin": null
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 20px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "50px"
            },
            "stretched": false,
            "padding": 0,
            "container": {
              "minWidth": 375,
              "alignment": null
            },
            "scrollEffect": null,
            "background": null,
            "alignment": {
              "position": "center",
              "margin": null
            },
            "verticalAlignment": {
              "position": "center",
              "margin": null
            }
          }
        },
        content: null,
        widgets: [{
          type: MENU_CONTAINER,
          name: "MenuContainer",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "rotate": "0deg"
                },
                "width": "auto",
                "height": "auto"
              },
              "regular": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 0,
                    "g": 0,
                    "b": 0,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "hover": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "alignment": {
                "position": "center",
                "margin": null
              },
              "trayAlignment": {
                "position": "center",
                "margin": null
              },
              "padding": 0,
              "itemHorizontalPadding": 20,
              "itemVerticalPadding": 8,
              "trayBackground": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "animation": null
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "rotate": "0deg"
                },
                "width": "40px",
                "height": "30px"
              },
              "regular": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 0,
                    "g": 0,
                    "b": 0,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "hover": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "alignment": {
                "position": "center",
                "margin": null
              },
              "trayAlignment": {
                "position": "center",
                "margin": null
              },
              "padding": 0,
              "itemHorizontalPadding": 0,
              "itemVerticalPadding": 0,
              "trayBackground": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "animation": null
            }
          },
          content: [
            {
              uid: shortid(),
              name: 'Home',
              action: null,
              children: null
            },
            {
              uid: shortid(),
              name: 'About',
              action: null,
              children: null
            },
            {
              uid: shortid(),
              name: 'Gallery',
              action: null,
              children: null
            }
          ]
        }
        ]
      }

    case 'standard':
      return {
        type: MENU,
        name: "Menu",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "50px"
            },
            "stretched": false,
            "padding": 0,
            "container": {
              "minWidth": 1200,
              "alignment": "center"
            },
            "scrollEffect": "NONE",
            "background": {
              "type": "color",
              "color": {
                "type": "solid",
                "r": 0,
                "g": 183,
                "b": 202,
                "a": 1
              },
              "media": null,
              "opacity": 0,
              "scale": null,
              "position": null
            },
            "alignment": {
              "position": "center",
              "margin": null
            },
            "verticalAlignment": {
              "position": "center",
              "margin": null
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "50px"
            },
            "stretched": false,
            "padding": 0,
            "container": {
              "minWidth": 375,
              "alignment": null
            },
            "scrollEffect": null,
            "background": null,
            "alignment": {
              "position": "center",
              "margin": null
            },
            "verticalAlignment": {
              "position": "center",
              "margin": null
            }
          }
        },
        content: null,
        widgets: [{
          type: MENU_CONTAINER,
          name: "MenuContainer",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "rotate": "0deg"
                },
                "width": "auto",
                "height": "auto"
              },
              "regular": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 0,
                    "g": 183,
                    "b": 202,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 183,
                  "b": 202,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "hover": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "alignment": {
                "position": "center",
                "margin": null
              },
              "trayAlignment": {
                "position": "center",
                "margin": null
              },
              "padding": 0,
              "itemHorizontalPadding": 8,
              "itemVerticalPadding": 8,
              "trayBackground": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "animation": null
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "rotate": "0deg"
                },
                "width": "40px",
                "height": "30px"
              },
              "regular": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "hover": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "alignment": {
                "position": "center",
                "margin": null
              },
              "trayAlignment": {
                "position": "center",
                "margin": null
              },
              "padding": 0,
              "itemHorizontalPadding": 0,
              "itemVerticalPadding": 0,
              "trayBackground": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "animation": null
            }
          },
          content: [
            {
              uid: shortid(),
              name: 'Home',
              action: null,
              children: null
            },
            {
              uid: shortid(),
              name: 'About',
              action: null,
              children: null
            },
            {
              uid: shortid(),
              name: 'Gallery',
              action: null,
              children: null
            }
          ]
        },

        ]
      }

    case 'modern':
      return {
        type: MENU,
        name: "Menu",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "100px"
            },
            "stretched": false,
            "padding": 0,
            "container": {
              "minWidth": 1200,
              "alignment": "center"
            },
            "scrollEffect": "NONE",
            "background": {
              "type": "color",
              "color": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "media": null,
              "opacity": 0,
              "scale": null,
              "position": null
            },
            "alignment": {
              "position": "center",
              "margin": null
            },
            "verticalAlignment": {
              "position": "center",
              "margin": null
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "50px"
            },
            "stretched": false,
            "padding": 0,
            "container": {
              "minWidth": 375,
              "alignment": null
            },
            "scrollEffect": null,
            "background": null,
            "alignment": {
              "position": "center",
              "margin": null
            },
            "verticalAlignment": {
              "position": "center",
              "margin": null
            }
          }
        },
        content: null,
        widgets: [{
          type: MENU_CONTAINER,
          name: "Menu Container",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "rotate": "0deg"
                },
                "width": "auto",
                "height": "auto"
              },
              "regular": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 101,
                      "g": 101,
                      "b": 101,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 0,
                  "g": 183,
                  "b": 202,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "hover": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 183,
                      "b": 202,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "alignment": {
                "position": "center",
                "margin": null
              },
              "trayAlignment": {
                "position": "center",
                "margin": null
              },
              "padding": 0,
              "itemHorizontalPadding": 20,
              "itemVerticalPadding": 8,
              "trayBackground": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "animation": null
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "rotate": "0deg"
                },
                "width": "40px",
                "height": "30px"
              },
              "regular": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "hover": {
                "menuStyles": {
                  "font": {
                    "style": {
                      "bold": false,
                      "italic": false,
                      "underline": false
                    },
                    "fontSize": "14",
                    "fontFamily": null,
                    "lineSpacing": null,
                    "letterSpacing": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    }
                  },
                  "background": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "width": "0",
                    "radius": {
                      "lock": false,
                      "topLeft": "0",
                      "topRight": "0",
                      "bottomLeft": "0",
                      "bottomRight": "0"
                    }
                  },
                  "shadow": null
                },
                "dropdownColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "dropdownBackground": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "dropdownBorder": {
                  "sides": null,
                  "color": {
                    "type": "solid",
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                  },
                  "width": "0",
                  "radius": {
                    "lock": false,
                    "topLeft": "0",
                    "topRight": "0",
                    "bottomLeft": "0",
                    "bottomRight": "0"
                  }
                }
              },
              "alignment": {
                "position": "center",
                "margin": null
              },
              "trayAlignment": {
                "position": "center",
                "margin": null
              },
              "padding": 0,
              "itemHorizontalPadding": 0,
              "itemVerticalPadding": 0,
              "trayBackground": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "animation": null
            }
          },
          content: [
            {
              uid: shortid(),
              name: 'Home',
              action: null,
              children: null
            },
            {
              uid: shortid(),
              name: 'About',
              action: null,
              children: null
            },
            {
              uid: shortid(),
              name: 'Gallery',
              action: null,
              children: null
            }
          ]
        },

        ]
      }

    default:
      return null;
  }
}

export const menus = [
  {
    id: 'basic_Menu',
    name: 'Basic  Menu',
    render: () => {
      return <img className={cx(styles.menu, styles.basic)} src="/images/palette/menu/basicMenu.png" />
    },
    data: generateMenuData('basic')
  },
  {
    id: 'standard_Menu',
    name: 'Standard Menu',
    render: () => {
      return <img className={cx(styles.menu, styles.basic)} src="/images/palette/menu/standardMenu.png" />
    },
    data: generateMenuData('standard')
  },
  {
    id: 'modern_Menu',
    name: 'Modern Menu',
    render: () => {
      return <img className={cx(styles.menu, styles.basic)} src="/images/palette/menu/modernMenu.png" />
    },
    data: generateMenuData('modern')
  }
]